<template>
  <div class="center-box">
    <div class="center-sum j-flex">
      <div class="d-column d-aligncnter">
        <div>昨日锻炼人次</div>
        <div class="num">{{ lastSum }}</div>
      </div>
      <div class="d-column d-aligncnter">
        <div>累计锻炼人次</div>
        <div class="num">{{ activeSum }}</div>
      </div>
      <div class="d-column d-aligncnter">
        <div>今日锻炼人次</div>
        <div class="num">{{ activeTodaySum }}</div>
      </div>
    </div>
    <div class="ccbg" ref="ccbg">
      <img src="../../../assets/img/cockpit/line-left.svg" class="center-bg" style="left: -20px" />
      <img src="../../../assets/img/cockpit/line-right.svg" class="center-bg" style="top: -32px; left: 16px" />
      <el-carousel
        ref="myCarousel"
        trigger="click"
        height="478px"
        :interval="5000"
        :initial-index="swipeIndex"
        @change="swipeChange"
      >
        <el-carousel-item v-for="(item, i) in venueData" :key="'list_' + i" style="cursor: pointer">
          <div class="d-center" style="width: 100%" @click="pageToVenue(item)">
            <div style="width: 660px; position: relative; height: 375px">
              <el-image style="width: 660px; height: 375px" fit="cover" :src="item.url"></el-image>
              <div class="center-name d-allcenter">{{ item.venueName }}</div>
            </div>
          </div>
          <div class="d-aligncnter swipe-style d-between" style="padding: 16px">
            <div class="d-aligncnter">
              <div class="d-column">
                <div style="font-size: 14px">实时热度</div>
                <div class="center-num">{{ item.ratio }}%</div>
              </div>
              <div class="rate-chart">
                <img :src="getCurrImg(index, item.ratio / 5)" v-for="(each, index) in 20" :key="'rate_' + each" />
              </div>
            </div>
            <div class="d-aligncnter">
              <div class="d-column" style="margin: 0 8px 0 32px">
                <div style="font-size: 14px">锻炼男生</div>
                <div class="center-num">{{ item.boyNum }}人</div>
              </div>
              <el-progress
                type="circle"
                :percentage="getCurrCircle(item.boyNum, item.number)"
                :stroke-width="8"
                :width="60"
                :show-text="false"
                stroke-linecap="square"
                define-back-color="#009AFE30"
                color="#009AFE"
              ></el-progress>
              <div class="d-column" style="margin: 0 8px 0 32px">
                <div style="font-size: 14px">锻炼女生</div>
                <div class="center-num">{{ item.girlNum }}人</div>
              </div>
              <el-progress
                type="circle"
                :percentage="getCurrCircle(item.girlNum, item.number)"
                :stroke-width="8"
                :width="60"
                :show-text="false"
                stroke-linecap="square"
                define-back-color="#B45EFA30"
                color="#B45EFA"
              ></el-progress>
            </div>
          </div>
        </el-carousel-item>
      </el-carousel>
      <div class="d-aligncnter d-allcenter" style="width: 100%; position: relative; z-index: 999; margin-top: 8px">
        <div @click="changeSwipePrev" class="hand d-allcenter" style="height: 48px; width: 48px">
          <el-image style="width: 24px; height: 24px" fit="cover" :src="prevImg"></el-image>
        </div>
        <div style="max-width: 388px; overflow-x: scroll; height: 48px; overflow-y: hidden">
          <div
            class="d-aligncnter"
            style="height: 48px"
            :style="{ width: venueData.length * 56 + 'px', marginLeft: swipeLeftData + 'px' }"
          >
            <div
              v-for="(item, index) in venueData"
              :key="'samll_' + index"
              style="margin: 0 4px; cursor: pointer"
              @click="changeSwipeIndex(index)"
              class="my-options d-allcenter"
              :class="{ 'my-options-active': index == swipeIndex }"
            >
              <el-image style="width: 48px; height: 48px" fit="cover" :src="item.url"></el-image>
            </div>
          </div>
        </div>

        <div @click="changeSwipeNext" class="hand d-allcenter" style="height: 48px; width: 48px">
          <el-image style="width: 24px; height: 24px" fit="cover" :src="nextImg"></el-image>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['lastSum', 'activeTodaySum', 'activeSum', 'venueData'],
  data() {
    return {
      groundplayone: 54,
      groundplaytwo: 63,
      chartHeight: '',
      lineTop: '',
      danger: false,
      bxccIndex: 0,
      nxccIndex: 1,
      ltygIndex: 2,
      lqcIndex: 3,
      fyccIndex: 3,
      swipeIndex: 0,
      prevImg: require('../../../assets/img/cockpit/prev.svg'),
      nextImg: require('../../../assets/img/cockpit/next.svg'),
      swipeLeftData: 0,
      handClick: false,
    }
  },
  created() {},
  mounted() {
    // let height = this.$refs.pg1.offsetHeight
    // this.chartHeight = (height * 0.49) / 10 + 'px'
    // this.lineTop = ((height * 0.6) / 100) * 8
    window.onresize = () => {
      return (() => {
        let height = this.$refs.ccbg.offsetHeight
        this.chartHeight = (height * 0.49) / 10 + 'px'
        this.lineTop = ((height * 0.6) / 100) * 8
      })()
    }

    // for (let i = 0; i < this.venueData.length; i++) {
    //   if (this.venueData[i].code == 'NORTH_CAMPUS_PLAYGROUND') {
    //     this.bxccIndex = i
    //     console.log('this.bxccIndex:', this.bxccIndex)
    //   } else if (this.venueData[i].code == 'SOUTH_CAMPUS_PLAYGROUND') {
    //     this.nxccIndex = i
    //   } else if (this.venueData[i].code == 'SOUTH_CAMPUS_GYMNASIUM') {
    //     this.ltygIndex = i
    //   } else if (this.venueData[i].code == 'SOUTH_CAMPUS_BASKETBALL_COURT') {
    //     this.lqcIndex = i
    //   } else if (this.venueData[i].code == 'SOUTH_CAMPUS_RAIN_PROOF_PLAYGROUND') {
    //     this.fyccIndex = i
    //   }
    // }
  },
  computed: {
    getCurrImg() {
      return function (index, sum) {
        if (index < sum) return require('../../../assets/img/cockpit/activechart.svg')
        return require('../../../assets/img/cockpit/chart.svg')
      }
    },
    getCurrCircle() {
      return function (num, sum) {
        if (sum == 0) return 0
        else if (num > sum) return 100
        else return (num / sum).toFixed(2) * 100
      }
    },
  },
  methods: {
    pageToVenue(data) {
      console.log(data)
      this.$router.push({
        path: '/cockpit/venues',
        query: {
          title: data.venueName,
          venueId: data.venueId,
        },
      })
    },
    changeSwipeIndex(index) {
      this.handClick = true
      this.$refs.myCarousel.setActiveItem(index)
    },
    changeSwipePrev() {
      this.$refs.myCarousel.prev()
    },
    changeSwipeNext() {
      this.$refs.myCarousel.next()
    },
    swipeChange(data) {
      this.swipeIndex = data

      if (this.handClick) {
        this.handClick = false
      } else {
        if (data > 3) {
          this.swipeLeftData = -56 * (data - 3)
          if (data > this.venueData.length - 4) {
            this.swipeLeftData = -56 * (this.venueData.length - 7)
          } else {
            this.swipeLeftData = -56 * (data - 3)
          }
        } else {
          this.swipeLeftData = 0
        }
      }
    },
  },
}
</script>
<style scoped lang="scss">
.center-sum {
  width: 60%;
  margin-left: 20%;
  font-size: 18px;
  margin-top: 24px;
  .num {
    font-size: 22px;
    color: #00b371;
    font-weight: 600;
  }
}
.center-box {
  width: 100%;
  height: calc(612px - 0px);
}
.ccbg {
  margin-left: 16px;
  margin-top: 16px;
  width: calc(100% - 24px);
  height: 590px;
  padding-top: 32px;
  position: relative;
  .center-bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
  .playground {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
  }
  .old-img {
    width: calc(100% - 16px);
    height: calc(100% - 16px);
    margin-left: 8px;
    margin-top: 8px;
    opacity: 0.2;
  }
  .pg1 {
    position: absolute;
    top: 48px;
    left: 58px;
    width: 200px;
    height: 324px;
    cursor: pointer;
  }
  .pg2 {
    position: absolute;
    top: 48px;
    right: 58px;
    width: 200px;
    height: 324px;
    cursor: pointer;
  }
  .pg-name {
    width: 100%;
    text-align: center;
    font-size: 16px;
    margin-top: 32px;
  }

  .name-rate {
    width: 100%;
    text-align: center;
    font-size: 16px;
    position: absolute;
    bottom: 206px;
    z-index: 99;
  }
  .old {
    bottom: auto;
    top: calc(14% - 1px);
    z-index: 99;
  }
  .fy-name {
    color: #fff;
    cursor: pointer;
  }
  .fy-rate {
    color: #00b371;
    cursor: pointer;
  }
  .center-ground {
    cursor: pointer;
    position: absolute;
    top: 58px;
    left: 290px;
    cursor: pointer;
  }
  .fy-ground {
    width: 629px;
    height: 172px;
    position: absolute;
    left: 74px;
    bottom: 38px;
    cursor: pointer;
  }
  .ground-gb {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: linear-gradient(284.82deg, #ffb612 3.75%, #339571 78.94%);
    opacity: 0.56;
  }
  .blank {
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    background: url('../../../assets/img/cockpit/shadow.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .lines {
    width: 100%;
    position: absolute;
    left: 0;
    height: 100%;
    background: url('../../../assets/img/cockpit/lines.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
  }
  .line {
    width: 20%;
    border-bottom: 2px solid #007a4d;
    margin-left: 40%;
    margin-top: 4px;
    position: relative;
    .line-circle-l {
      border-radius: 50%;
      background: #007a4d;
      width: 6px;
      height: 6px;
      position: absolute;
      top: -2px;
      left: 0;
    }
    .line-circle-r {
      border-radius: 50%;
      background: #007a4d;
      width: 6px;
      height: 6px;
      position: absolute;
      top: -2px;
      right: 0;
    }
  }
  .pg-rate {
    width: 100%;
    text-align: center;
    font-size: 22px;
    margin: 4px 0;
    color: #00b371;
  }
  .rate-chart {
    width: calc(100% - 100px);
    margin-left: 10px;
    display: grid;
    grid-template-columns: repeat(10, 10%);
    align-content: center;
    justify-items: center;
    img {
      width: 17.14px;
      height: 30px;
      padding: 4px 8px;
    }
  }
}
.danger {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.danger-circle {
  width: 12vw;
  height: 12vw;
  background: #de3831;
  border-radius: 50%;
}
.circle {
  animation: warn 1.5s linear;
  animation-iteration-count: infinite;
  box-shadow: 0 0 50px 30px #de3831cc inset;
}
@keyframes warn {
  0% {
    transform: scale(0.4);
    opacity: 0.4;
  }

  25% {
    transform: scale(0.6);
    opacity: 0.35;
  }

  50% {
    transform: scale(1);
    opacity: 0.3;
  }

  75% {
    transform: scale(1.3);
    opacity: 0.25;
  }

  100% {
    transform: scale(1.6);
    opacity: 0.2;
  }
}
.last {
  height: 142px;
  border: 1.79px solid #007a4d;
  width: 199px;
  border: 1.79px solid #007a4d;
  margin-top: 16px;
}
.center-name {
  position: absolute;
  bottom: 0px;
  left: 0;
  right: 0;
  width: 100%;
  background: linear-gradient(180deg, rgba(23, 41, 34, 0.5), rgba(0, 0, 0, 0.5) 100%);
  height: 50px;
  color: #fff;
  font-size: 20px;
}
.swipe-style {
  font-size: 16px;
}
.ccbg ::v-deep .el-carousel__button {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: 2px solid #007a4d;
  background: transparent;
  display: none;
}
.ccbg ::v-deep .el-carousel__indicator.is-active button {
  background: #007a4d;
  width: 16px;
  border-radius: 90px;
}
.ccbg ::v-deep .el-carousel__indicators--horizontal {
  display: flex;
}
.hand {
  cursor: pointer;
}
.my-options {
  border-radius: 8px;
  overflow: hidden;
  opacity: 0.2;
  width: 48px;
  height: 48px;
}
.my-options-active {
  border-radius: 8px;
  opacity: 1;
}
.center-num {
  font-size: 18px;
}
</style>
